import { Link } from "react-router-dom";

function Projects(props) {
  const {projects} = props;

  return (
    <>
      {projects.map((project) =>
        <Link key={project.id} to={project.url}>
          <div className="project-link">
            <div>{project.title}</div>
            <div>{project.year}</div>
          </div>
        </Link>
      )}
    </>
  );
}

export default Projects;